
import '../../layouts/Login/login.scss'
import {  Outlet } from 'react-router-dom';

const Login = () => {    
    return (
        <>
        <main className="main-login min-h-screen flex items-center w-full">
            <div className='my-0 mx-auto'>
                <Outlet />
            </div>
        </main>
        </>
    );
}

export default Login;


